/**
 * LegalConsent Component
 * Displays terms of service and privacy policy consent text with links.
 */

import React from "react";
import { Box, Typography, Link } from "../../design-system";
import { colors } from "../../design-system/colors";
import { LEGAL } from "../constants/onboardingText";

const legalTextStyle = {
  color: colors.text.tertiary,
  fontSize: "15px",
  fontWeight: 400,
};

const legalLinkStyle = {
  ...legalTextStyle,
  textDecoration: "underline",
};

const LegalConsent: React.FC = () => (
  <Box sx={{ textAlign: "center", marginTop: "88px" }}>
    <Typography variant="body" sx={legalTextStyle}>
      {LEGAL.CONSENT_PREFIX}
      <Link
        href={LEGAL.TERMS_URL}
        target="_blank"
        rel="noopener noreferrer"
        variant="action"
        sx={legalLinkStyle}
      >
        {LEGAL.TERMS_OF_SERVICE}
      </Link>
    </Typography>
    <Typography variant="body" sx={legalTextStyle}>
      {LEGAL.PRIVACY_LINE}{" "}
      <Link
        href={LEGAL.PRIVACY_URL}
        target="_blank"
        rel="noopener noreferrer"
        variant="action"
        sx={legalLinkStyle}
      >
        {LEGAL.PRIVACY_POLICY}
      </Link>
    </Typography>
  </Box>
);

export default LegalConsent;
